const EMAIL_KEY = 'userEmail';

export function rememberEmail(email) {
	window.localStorage.setItem(EMAIL_KEY, email);
}

export function getRememberedEmail() {
	return window.localStorage.getItem(EMAIL_KEY);
}
